<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div
            class="h-screen flex w-full bg-img vx-row no-gutter items-center justify-center"
            id="page-login"
    >
        <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4" v-if="isLogin">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row no-gutter justify-center items-center">
                        <div class="vx-col hidden lg:block lg:w-1/2">
                            <img id="img-login" src="@/assets/images/pages/login.png" alt="login" class="mx-auto"/>
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-8">
                                    <h4 class="mb-4">Login</h4>
                                    <p>Welcome back, please login to your account.</p>
                                </div>
                                <vs-input
                                        v-validate="'required|email'"
                                        data-vv-validate-on="blur"
                                        name="email"
                                        icon="icon icon-user"
                                        icon-pack="feather"
                                        label-placeholder="Email"
                                        v-model="email"
                                        class="w-full no-icon-border"
                                        id="txt-email"
                                />
                                <span class="text-danger text-sm">{{ errors.first('email') }}</span>

                                <vs-input
                                        data-vv-validate-on="blur"
                                        v-validate="'required'"
                                        type="password"
                                        name="password"
                                        icon="icon icon-lock"
                                        icon-pack="feather"
                                        label-placeholder="Password"
                                        v-model="password"
                                        class="w-full mt-6 no-icon-border"
                                        id="txt-password"
                                />
                                <span class="text-danger text-sm">{{ errors.first('password') }}</span>

                                <div class="flex flex-wrap justify-between my-5">
                                    <vs-checkbox id="chk-remember-me" v-model="checkbox_remember_me" class="mb-3">Remember Me</vs-checkbox>
                                </div>
                                <!--
                                <vs-button id="btn-register" type="border" to="/register">Register</vs-button>
                                -->
                                <vs-button id="btn-login" class="float-right mb-12" :disabled="!validateForm" @click="login">Login
                                
                                </vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                isLogin: false,
                email: "",
                password: "",
                checkbox_remember_me: false
            };
        },
        beforeCreate: function () {
            console.log(this.$route.query.continue);
            let continueQuery = this.$route.query.continue;
            if (continueQuery !== undefined && continueQuery != null) {
                console.log(this.$route.query.continue)
                let payload = {
                    redirect_uri: continueQuery
                }

                this.$store.dispatch("auth/ssoAuthorize", payload);
            }
        },
        computed: {
            validateForm() {
                return !this.errors.any() && this.email != "" && this.password != "";
            }
        },
        methods: {
            login() {
                console.log(this.checkbox_remember_me)
                const payload = {
                    checkbox_remember_me: this.checkbox_remember_me,
                    userDetails: {
                        email: this.email,
                        password: this.password
                    },
                    notify: this.$vs.notify
                };
                this.$store.dispatch("auth/login", payload);
            },
            notifyAlreadyLogedIn() {
                this.$vs.notify({
                    title: "Login Attempt",
                    text: "You are already logged in!",
                    iconPack: "feather",
                    icon: "icon-alert-circle",
                    color: "warning"
                });
            },
            registerUser() {
                if (this.$store.state.auth.isUserLoggedIn()) {
                    this.notifyAlreadyLogedIn();
                    return false;
                }
                this.$router.push("/auth/register");
            }
        },
        mounted() {
            if (localStorage.getItem("userInfo") !== undefined) {
                this.isLogin = true
            }
        }
    };
</script>

<style lang="scss">
    #page-login {
        .social-login {
            .bg-facebook {
                background-color: #1551b1;
            }

            .bg-twitter {
                background-color: #00aaff;
            }

            .bg-google {
                background-color: #4285f4;
            }

            .bg-github {
                background-color: #333;
            }
        }
    }
</style>